import {httpGet} from "./http";

const optionsUrl = window.env.BACKEND_API_URL + "/options";
const bookCarModelName = "App\\Models\\Bookables\\BookCar";

const getAvailableCarStatuses = async (signal) => {
    const model = encodeURIComponent(bookCarModelName);
    const option = encodeURIComponent('state');
    const availableStatusUrl = `${optionsUrl}/model?model=${model}&option=${option}`;

    return await httpGet(availableStatusUrl, signal);
};

const getCarRateClasses = async (signal) => {
    const model = encodeURIComponent(bookCarModelName);
    const option = encodeURIComponent('rate_class');
    const carRateClassesUrl = `${optionsUrl}/model?model=${model}&option=${option}`;

    return await httpGet(carRateClassesUrl, signal);
};

export {getAvailableCarStatuses, getCarRateClasses};
